module.exports = __webpack_public_path__ + "vfn-assets/img/personaje.0064f175.png";